import React from 'react';
import Skeleton from 'react-loading-skeleton';

interface VehicleCardSkeletonProps {
  children: any;
  renderSkeleton: boolean;
}

var VehicleCardSkeleton = ({
  children,
  renderSkeleton,
}: VehicleCardSkeletonProps) => {
  if (renderSkeleton) {
    return <Skeleton />;
  }

  return <>{children}</>;
};

export default VehicleCardSkeleton;
